<template>
	<div id="dashboard-index">
		<Messages />
		<!-- <Reporting /> -->
		<div class="temp-slot"></div>
		<News />
	</div>
</template>

<script>
import Tour from '@/services/TourPlugin.js';
import Messages from './Messages/Index';
import Reporting from './Reporting/Index';
import News from './News';

export default {
	name: 'dashboard-index',
	components: {
		Messages,
		Reporting,
		News,
	},
	mounted() {
		//this.Tour01();
	},
	methods: {
		Tour01() {
			Tour.Tour01();
		},
	},
};
</script>

<style lang="scss">
#dashboard-index {
	display: grid;
	grid-template-columns: 1fr;
	grid-auto-rows: auto;
	grid-column-gap: 30px;
	grid-row-gap: 30px;
	width: 100%;

	.section-title {
		color: var(--primary-color);
	}

	.message-box {
		padding: 50px;
		background-color: #fff;
		font-size: 0.875rem;
		width: 600px;
		border: 1px solid #b9b9b9;
		margin: 50px;
	}

	@media screen and (min-width: 992px) {
		grid-template-columns: repeat(3, 1fr);
		grid-auto-rows: 1fr;
		grid-column-gap: 50px;
		grid-row-gap: 50px;
	}
}
</style>
